import { useQuery } from '@tanstack/react-query';
import request from '@utils/request';

export function useGetTablesPage(propertyId: number, language: string) {
  return useQuery({
    queryKey: getTablesPageKey({ propertyId, language }),
    queryFn: () => getTablesPage({ propertyId, language }),
    staleTime: Infinity,
    cacheTime: Infinity,
  });
}

export async function getTablesPage({
  propertyId,
  language,
}: {
  propertyId: number;
  language: string;
}) {
  const response = await request.v2.get(`${propertyId}/pages/tables/${language}`);
  if (response.status === 204) {
    return null;
  }
  return response.data;
}

export const getTablesPageKey = ({
  propertyId,
  language,
}: {
  propertyId: number;
  language: string;
}) => ['tablesPage', propertyId, language];
